import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components';
import type { PreventionAlert } from 'types/preventionAlerts';
import { formatMonthYear } from 'utils';
import { PreventionRow } from './PreventionRow';
import { RowActionButton, RowActionCheckIcon, RowSubtitle } from './DuePreventionsSection.styles';

interface InfluenzaRowProps {
  alert: PreventionAlert;
  name: string;
  onRecord?: () => void;
}

export const InfluenzaRow: React.FC<InfluenzaRowProps> = ({ alert, name, onRecord }) => {
  const { t } = useTranslation();
  const recordLabel = t('result.preventions.influenza.recordButton');

  const subtitle = alert.lastPerformedAt
    ? t('result.preventions.influenza.lastDone', { date: formatMonthYear(alert.lastPerformedAt) })
    : t('result.preventions.influenza.neverDone');

  const actions = alert.recordable ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <RowActionButton type="button" aria-label={recordLabel} onClick={onRecord}>
          <RowActionCheckIcon />
        </RowActionButton>
      </TooltipTrigger>
      <TooltipContent>
        <p>{recordLabel}</p>
      </TooltipContent>
    </Tooltip>
  ) : undefined;

  return (
    <PreventionRow alert={alert} name={name} actions={actions}>
      <RowSubtitle>{subtitle}</RowSubtitle>
    </PreventionRow>
  );
};
